import { render } from "./GemMechanism12.vue?vue&type=template&id=52726580&scoped=true"
import script from "./GemMechanism12.vue?vue&type=script&lang=js"
export * from "./GemMechanism12.vue?vue&type=script&lang=js"

import "./GemMechanism12.vue?vue&type=style&index=0&id=52726580&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52726580"]])

export default __exports__